import { useTheme } from "@emotion/react";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useMemo, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // import first
import { axiosInstance, baseURL } from "src/api/axios";
import PageContainer from "src/components/container/PageContainer";
import image from "../assets/images/backgrounds/background-card-reports.png";

const cities = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and",
  "The Government of NCT of Delhi",
  "Jammu & Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];
const occupations = [
  "Bank Employee",
  "Student",
  "Financial Advisor",
  "Sales Manager",
  "DSA",
  "Influencer",
  "Professional",
  "Others",
];
const UserProfile = () => {
  const theme = useTheme();
  const [user, setUser] = useState({
    name: "",
    phoneNumber: "",
    account_name: "",
    account_number: "",
    ifsc_code: "",
    pinCode: "",
    email: "",
    occupation: "",
    city: cities[0],
  });

  useMemo(() => {
    axiosInstance.get("/users").then((response) => {
      if (response?.status === 200) {
        response.data["account_name"] =
          response.data.bankAccount?.account_name || "";
        response.data["account_number"] =
          response.data.bankAccount?.account_number || "";
        response.data["ifsc_code"] = response.data.bankAccount?.ifsc_code || "";
        setUser(response.data);
      }
    });
  }, []);

  const sendVerifyEmail = async (email) => {
    if (!email) {
      email = JSON.parse(localStorage.getItem("store"));
    }

    await axiosInstance
      .post(baseURL + "/auth/send-verification-email", {
        email: email?.user?.email || email?.email || email,
      })
      .then(() => {
        toast.success("Verification email Sent");
      })
      .catch((e) => {
        console.log(e);
        toast.error("Failed to send Email", { position: "bottom-center" });
      });
  };

  const updateUserData = (key, value) => {
    setUser((data) => {
      let new_obj = { ...data };
      new_obj[key] = value;
      return new_obj;
    });
  };

  const submit = () => {
    let {
      name,
      phoneNumber,
      pinCode,
      account_name,
      account_number,
      ifsc_code,
      city,
    } = user;
    if (!account_name.length) {
      toast.error(`account_name cannot be empty`);
      return;
    }
    if (!account_number.length) {
      toast.error(`bank_account cannot be empty`);
      return;
    }
    if (!ifsc_code.length) {
      toast.error(`ifsc_code cannot be empty`);
      return;
    }
    axiosInstance
      .patch("/users", {
        name,
        phoneNumber,
        pinCode,
        bankAccount: { account_name, account_number, ifsc_code },
        city,
      })
      .then((response) => {
        if (response?.status >= 200) {
          toast.success("Updated Data");
        }
      })
      .catch((error) => {
        console.log(error?.response?.data?.message);
        toast.error("Something went wrong Updating Profile");
      });
  };
  // <div style={{ translate:"35vw 170px" ,width:'150px', height:'150px',background:theme.palette.earnpati.main , borderRadius:'50%', position:'absolute', overflow:'hidden'}}>
  // <img src={logo} alt="" height={"90%"} style={{margin:'3px 0'}}/>
  // </div>
  return (
    <PageContainer
      title="User Profile | Earnpati"
      description="This is Users page for Earnpati Affiliates"
      sx={{ pr: 2 }}
    >
      <Card variant="outlined" sx={{ borderRadius: 5 }}>
        <img
          src={image}
          style={{ objectFit: "cover", height: "250px", width: "100%" }}
          alt=""
        />

        <CardContent>
          <Typography variant="h3" mb={2}>
            Profile Details
          </Typography>
          <form>
            <Grid
              container
              xs={12}
              spacing={2}
              justifyContent={"space-between"}
            >
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  InputLabelProps={{
                    shrink: user?.account_name ? true : false,
                  }}
                  value={user.account_name}
                  id="bank_account_name"
                  label="Account Holder Name"
                  variant="outlined"
                  onChange={(e) =>
                    updateUserData("account_name", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  InputLabelProps={{
                    shrink: user?.account_number ? true : false,
                  }}
                  value={user.account_number}
                  id="bank_account"
                  label="Bank Account No."
                  variant="outlined"
                  onChange={(e) =>
                    updateUserData("account_number", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  InputLabelProps={{ shrink: user.ifsc_code ? true : false }}
                  value={user.ifsc_code}
                  id="ifsc_code"
                  label="IFSC code"
                  variant="outlined"
                  onChange={(e) => updateUserData("ifsc_code", e.target.value)}
                />
              </Grid>
              <Grid container xs={12} md={6} spacing={2} margin="10px 0">
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Name"
                    id="name"
                    disabled
                    InputLabelProps={{ shrink: true }}
                    value={user.name}
                    variant="filled"
                    onChange={(e) => updateUserData("name", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="number"
                    disabled
                    InputLabelProps={{
                      shrink: user.phoneNumber ? true : false,
                    }}
                    value={user.phoneNumber}
                    label="Phone Number"
                    variant="filled"
                    onChange={(e) =>
                      updateUserData("phoneNumber", e.target.value)
                    }
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={user.email}
                    disabled={user?.isEmailVerified}
                    id="email"
                    label="Email"
                    variant="outlined"
                    onChange={(e)=>setUser((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }))}
                  />
                </Grid>
                <Grid item xs={12}>
                  {!user?.isEmailVerified ? (
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{
                        bgcolor: theme.palette.primary.main,
                        fontWeight: 700,

                        color: "white",
                        "&:hover": {
                          backgroundColor: theme.palette.earnpati.title,
                          cursor: "pointer",
                        },
                      }}
                      size="large"
                      onClick={(e) => {
                        e.preventDefault();

                        sendVerifyEmail(user?.email);
                      }}
                    >
                      VerifyEmail
                    </Button>
                  ) : (
                    <TextField
                      fullWidth
                      id="number"
                      label="number"
                      variant="outlined"
                      sx={{ visibility: "hidden" }}
                    />
                  )}
                </Grid>
              </Grid>
              <Grid container xs={12} md={5} spacing={2} margin="10px 0">
                <Grid item xs={12}>
                  <FormControl sx={{ flex: 1, width: "100%" }}>
                    <InputLabel
                      InputLabelProps={{ shrink: user.city ? true : false }}
                      id="city"
                    >
                      City
                    </InputLabel>
                    <Select
                      fullWidth
                      labelId="city"
                      id="city"
                      label="City"
                      value={user.city || cities[0]}
                      onChange={(e) => updateUserData("city", e.target.value)}
                    >
                      <MenuItem value={user.city}>{user.city}</MenuItem>
                      {cities.map((city) => (
                        <MenuItem value={city}>{city}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    InputLabelProps={{ shrink: user.pinCode ? true : false }}
                    inputProps={{
                      sx: {
                        "::-webkit-inner-spin-button": { display: "none" },
                        "::-webkit-outer-spin-button": { display: "none" },
                      },
                    }}
                    value={user.pinCode}
                    id="pincode"
                    type="number"
                    label="Pincode"
                    variant="outlined"
                    onChange={(e) => updateUserData("pinCode", e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl sx={{ flex: 1, width: "100%" }}>
                    <InputLabel id="occupation">Occupation</InputLabel>
                    <Select
                      fullWidth
                      labelId="occupation"
                      id="occupation"
                      label="Occupation"
                      value={user.occupation || occupations[0]}
                      onChange={(e) =>
                        updateUserData("occupation", e.target.value)
                      }
                    >
                      {occupations.map((job) => (
                        <MenuItem value={job}>{job}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: theme.palette.earnpati.main,
                      fontWeight: 700,
                      width: { xs: "100%", lg: "250px" },
                      color: "white",
                      "&:hover": {
                        backgroundColor: theme.palette.earnpati.nav,
                        cursor: "pointer",
                      },
                    }}
                    size="large"
                    onClick={(e) => {
                      e.preventDefault();

                      submit();
                    }}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
      <ToastContainer />
    </PageContainer>
  );
};
export default UserProfile;
